import { Component,  OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, Observable, of,  } from 'rxjs';  // RxJS 6 syntax


import { PS_Supplier_Qual_Docs_2_Result, Supplier, DocumentStatut, SimpleReponseResult, PafDocument, DocTyp } from '../../../all-models';
import { ContactsService, DocumentsService, SharedDataService, SuppliersService } from '../../../all-services';

import { SupplierDetailsStepBase, checkValidityEvent } from '../supplier-details/suppliers-details-step-base';
import { SaveStepParam } from '../supplier-details/SaveStepParam';

@Component({
  selector: 'app-supplier-quality-docs',
  templateUrl: './supplier-quality-docs.component.html',
  styleUrls: ['./supplier-quality-docs.component.scss']
})
export class SupplierQualityDocsComponent extends SupplierDetailsStepBase implements OnChanges, OnDestroy {
  lstPafDocuments: PafDocument[]=[];
  lstDocTyps: DocTyp[]=[] ;
  lstDocStatuts: DocumentStatut[]=[];  
  lstSupplierQualDocs: PS_Supplier_Qual_Docs_2_Result[] = [];
  isLoading: boolean = false;
  constructor(
    public sharedDatasSvc: SharedDataService,
    public docsSvc: DocumentsService,
    public suppliersSvc: SuppliersService,
    public route: ActivatedRoute,
    public contactsSvc: ContactsService) {
    super(sharedDatasSvc, docsSvc, suppliersSvc, route, contactsSvc);
  }


  
  ngOnInit(): void {
    forkJoin(
      [this.docsSvc.getPafDocuments(),
      this.docsSvc.getDocTyps(),
      this.docsSvc.getDocumentStatuts()
      
      ]).subscribe(res=>{
        this.lstPafDocuments=res[0];
        this.lstDocTyps=res[1];
        this.lstDocStatuts=res[2];
      }); 
    this.reload();    
    this.subscriptions.push(
      this.sharedDatasSvc.loggedProfilChange.subscribe(res => {
        this.reload();
      })
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['ocurrentstep'] && this.ocurrentstep) {
      setTimeout(() => {
        this.ocurrentstep.showSaveButton = (): boolean => { return this._ShowSaveButton() };
      }, 0);
      this.subscriptions.push(
        this.ocurrentstep.supplierReloaded.subscribe(id=>{
          this.reload();
        })
      );
    }
  }

  private _ShowSaveButton = (): any => {
    if (!this.canModifySupplier()) return false;
    return !(this.docsQualiteQualifDisabled && this.docsQualiteAutresDisabled);
  }

  get docsQualiteQualifDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_DOC_QUALITE_QUALIFICATION');
    //return ['ACH_OPERAT', 'QUAL', '3SE', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN', 'FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  get docsQualiteAutresDisabled(): boolean {
    if (!this.canModifySupplier()) return true;
    if (this.isCreatingSupplier) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_DOC_QUALITE_AUTRE');
    //return ['ACH_OPERAT', 'QUAL', '3SE', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN', 'FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  reload(afterloadCallBack:()=>any = null): void {
    this.isLoading = true;
    forkJoin([
      this.docsSvc.getSupplierQualDocs(this.sharedDatasSvc.lngCod, this.supplier.Id),
      this.docsSvc.getSupplierDocuments(this.supplier.Id),
      this.docsSvc.getDocumentStatuts()
    ])
      .subscribe(res => {
        this.lstSupplierQualDocs = res[0];
        this.supplier.SupplierDocuments = res[1];
        this.lstDocStatuts = res[2]
        this.isLoading = false;
        if (afterloadCallBack) afterloadCallBack();
      });
  }

  get lstQualifDocs(): PS_Supplier_Qual_Docs_2_Result[] {
    return this.lstSupplierQualDocs.filter(d => d.Screen == 'QUALITY/QUALIF');
  }
  get lstAutresDocs(): PS_Supplier_Qual_Docs_2_Result[] {
    return this.lstSupplierQualDocs.filter(d => d.Screen == 'QUALITY/OTHERS');
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }


  getStatutDoc(doc: PS_Supplier_Qual_Docs_2_Result): DocumentStatut {
    return this.lstDocStatuts.find(s => s.Id == doc.StatutId);
  }

  documentManquant(doc: PS_Supplier_Qual_Docs_2_Result): boolean {
    return doc.TopFic == 1 && (this.getStatutDoc(doc)?.Cod == 'EXPIRE' || (!doc.DocId || !doc.FullPath));
  }
  CanSaveDocuments(): boolean {
    let errorDocs = this.lstSupplierQualDocs.filter(d => this.documentManquant(d))
    return errorDocs.length == 0;
  }

  

  save(param: SaveStepParam): void {
    if (param.nextAction == 'forceScreen') {
      super.save(param);
      return;
    }
    if (param.nextAction == 'next' && !this.CanSaveDocuments()) {
      this.sharedDatasSvc.pafAlert('Msg_Documents_manquants');
      return;
    }
    let patchParam: Supplier = new Supplier();
    patchParam.Id = this.supplier.Id;
    patchParam.DocQualComments = this.supplier.DocQualComments;
    patchParam.RefStep = this.supplier.RefStep + (param.nextAction != 'screen' ? 1 : 0);
    this.suppliersSvc.PatchSimpleValues(this.supplier.Id, patchParam)
      .subscribe((res: SimpleReponseResult) => {
        this.reload(():void=>{
          super.save(param);
        }) ;
      });
  }




  onCheckValidity(event:checkValidityEvent): Observable<boolean | undefined>{
    if (event.stepNum!=this.screenValidity.step) return of(undefined);
    // let statutDepose: DocumentStatut = this.lstDocStatuts.find(s => s.Cod == 'A_VALIDER');
    // let isValid: boolean = !this.lstSupplierQualDocs.some(d => d.FullPath != null && d.StatutId != statutDepose.Id);
    // isValid = isValid && !this.lstSupplierQualDocs.some(d => d.TopFic == 1 && (!d.FullPath || d.StatutId != statutDepose.Id));
    // if (!this.isCreatingSupplier) isValid = true;
    // return of(isValid);
    
    return of(true);
  }


  supplierDocChange(doc: PS_Supplier_Qual_Docs_2_Result): void {
    if (!doc) return;
    let index: number = this.lstSupplierQualDocs.findIndex(d => d.DocId == doc.DocId);
    this.lstSupplierQualDocs.splice(index, 1, doc);
  }

  reloadList(event: boolean): void {
    this.reload();
  }

  readonlyQualDoc(typQualDoc: string): boolean {
    // if (this.sharedDatasSvc.profil?.Cod=='ADMIN') return false;
    // if (this.sharedDatasSvc.profil?.Cod=='FOURNISSEUR') return false;
    // return this.readonly;
    return (this.docsQualiteQualifDisabled && typQualDoc == 'qualif')
      || (this.docsQualiteAutresDisabled && typQualDoc == 'autres')
      || !this.isEditing();
  }

}
